import { Components } from '@mui/material';

export const MuiMenuItem: Components['MuiMenuItem'] = {
  styleOverrides: {
    root: {
      backgroundColor: 'background.paper',
    },
  },
};
